import React from 'react';
import { IconProps } from '@clarke-energia/foton-v2';
import { ButtonKind } from '@clarke-energia/foton-v2/dist/components/atoms/buttons/base-button';
import { HeroIcon } from '@clarke-energia/foton-v2';

interface ClipboardButtonProps {
  containerClassName?: string;
  copy?: {
    className?: string;
    text?: string;
    icon?: IconProps['icon'];
    kind?: ButtonKind;
    onClick?: () => void;
  };
  paste?: {
    className?: string;
    text?: string;
    icon?: IconProps['icon'];
    kind?: ButtonKind;
    onClick?: () => void;
  };
}

export default function ClipboardButtons({ containerClassName, copy, paste }: ClipboardButtonProps) {
  return (
    <div className={containerClassName}>
      <button
        type="button"
        onClick={() => {
          copy?.onClick?.();
        }}
        className={
          copy?.className &&
          'hover:bg-light-30 bg-light-20 rounded-[100px] p-2 border border-brand-gray-20 text-paragraph-small flex gap-2 items-center justify-center'
        }
      >
        {copy?.text ?? 'Copiar inputs'}
        <HeroIcon icon="Square2StackIcon" className="size-5 inline-block" />
      </button>

      <button
        type="button"
        onClick={() => {
          paste?.onClick?.();
        }}
        className={
          paste?.className &&
          'hover:bg-light-30 bg-light-20 rounded-[100px] p-2 border border-brand-gray-20 text-paragraph-small flex gap-2 items-center justify-center'
        }
      >
        {paste?.text ?? 'Colar inputs'}
        <HeroIcon icon="ClipboardDocumentListIcon" className="size-5 inline-block" />
      </button>
    </div>
  );
}
